import { supabase } from '@/integrations/supabase/client';

type RpcResult<T> = {
  data: T | null;
  error: { message?: string } | null;
};

type RpcMethod = <T>(
  fn: string,
  args?: Record<string, unknown>,
) => Promise<RpcResult<T>>;

export function callRpc<T>(fn: string, args?: Record<string, unknown>) {
  return (supabase.rpc as unknown as RpcMethod).call(supabase, fn, args);
}
